@let currentSlide = slide();

<div class="wrapper-dialog" [id]="currentSlide ? 'promo-timer-' + currentSlide.id : 'promo-timer-dialog'">
  <button type="button" class="close-btn" (click)="close()" [attr.aria-label]="'promo-timer-dialog.close' | translate">
    <div class="msi-cross"></div>
  </button>

  <h1 class="dialog-title">{{ 'promo-timer-dialog.title' | translate }}</h1>

  <div class="carousel">
    @if (!isFirst()) {
      <button
        type="button"
        class="carousel-arrow arrow-prev"
        (click)="prev()"
        [attr.aria-label]="'promo-timer-dialog.prevSlide' | translate"
      >
        <i class="msi-angle-left"></i>
      </button>
    }
    @if (!isLast()) {
      <button
        type="button"
        class="carousel-arrow arrow-next"
        (click)="next()"
        [attr.aria-label]="'promo-timer-dialog.nextSlide' | translate"
      >
        <i class="msi-angle-right"></i>
      </button>
    }

    <div
      class="carousel-viewport"
      [class.dragging]="isDragging()"
      (pointerdown)="onPointerDown($event)"
      (pointermove)="onPointerMove($event)"
      (pointerup)="onPointerUp($event)"
      (pointercancel)="onPointerCancel($event)"
    >
      <div class="carousel-track" [class.dragging]="isDragging()" [style.transform]="trackTransform()">
        @for (item of data.slides; track item.id) {
          <div class="slide">
            <div class="slide-banner" [ngClass]="item.backgroundCssClass" [style.color]="item.fontColor || null">
              <h2 class="slide-title">{{ item.title }}</h2>
              <p class="slide-text">{{ item.text }}</p>

              @if (item.showTimer && $index === currentIndex()) {
                <div class="countdown" aria-live="off">
                  <span class="countdown-label">{{ 'promo-timer-dialog.endsIn' | translate }}</span>
                  <div class="timer">
                    <div class="day">
                      {{ timer().days }}
                      <span class="timer-label">{{ 'profile.days' | translate: { days: timer().days } }}</span>
                    </div>
                    <div class="hour">
                      {{ timer().hours }}
                      <span class="timer-label">{{ 'timer-news.hours' | translate: { hours: timer().hours } }}</span>
                    </div>
                    <div class="minute">
                      {{ timer().minutes }}
                      <span class="timer-label">{{ 'timer-news.minutes' | translate: { minutes: timer().minutes } }}</span>
                    </div>
                    <div class="second">
                      {{ timer().seconds }}
                      <span class="timer-label">{{ 'timer-news.seconds' | translate: { seconds: timer().seconds } }}</span>
                    </div>
                  </div>
                </div>
              }
            </div>

            <div class="slide-footer">
              @if (item.links.length) {
                <div class="links">
                  @for (link of item.links; track $index) {
                    @if (link.url) {
                      <a
                        class="slide-link"
                        [ngClass]="link.cssClass"
                        [class.link-left]="link.position === 'left'"
                        [class.link-right]="link.position === 'right'"
                        [href]="link.url"
                        [target]="link.targetBlank ? '_blank' : '_self'"
                        [attr.rel]="link.targetBlank ? 'noopener noreferrer' : null"
                        (click)="close()"
                      >{{ link.title }}</a>
                    }
                  }
                </div>
              }
            </div>
          </div>
        }
      </div>
    </div>

    @if (data.slides.length > 1) {
      <div class="carousel-dots">
        @for (item of data.slides; track item.id; let i = $index) {
          <button
            type="button"
            class="dot"
            [class.active]="i === currentIndex()"
            (click)="goTo(i)"
            [attr.aria-label]="'promo-timer-dialog.goToSlide' | translate: { n: i + 1 }"
          ></button>
        }
      </div>
    }
  </div>
</div>
